import styled from '@emotion/styled';

import { inputFocusStyles, uppercaseLabelStyles } from './utils/mixins';

export const DetailLabel = styled.span`
  ${uppercaseLabelStyles}
`;
